import { SetStateAction, useSetAtom, WritableAtom } from 'jotai';

import { SimInventoryFiltersV2 } from 'src/simInventory/models/SimProfile.model';
import { useDebouncedIdSearch } from '../../Filters/hooks/useDebouncedIdSearch';

type IccidRangeType = Pick<SimInventoryFiltersV2, 'iccidFrom' | 'iccidTo'>;

type useSimDebouncedIdSearchProps = {
  iccidRangeFilterAtom: WritableAtom<IccidRangeType, [SetStateAction<IccidRangeType>], void>;
  searchTextFilterAtom: WritableAtom<string, [SetStateAction<string>], void>;
};

export const useSimDebouncedIdSearch = ({
  iccidRangeFilterAtom,
  searchTextFilterAtom,
}: useSimDebouncedIdSearchProps) => {
  const setIccidRange = useSetAtom(iccidRangeFilterAtom);

  return useDebouncedIdSearch({
    searchTextFilterAtom,
    onInputValueChange: (value) => {
      if (value !== '') {
        setIccidRange({ iccidFrom: '', iccidTo: '' });
      }
    },
  });
};
